import React, { useContext } from "react";

import { DispatchContext as HomeDispatchContext } from "bodycodi/cmap/app/components/cmap2010/home";
import { DispatchContext } from "bodycodi/cmap/app/components/common/context";
import {
  getDwk,
  isEmpty,
  timeFormat,
  recoverTag,
  callApi,
  blockEmoji,
  maskingMobile,
} from "bodycodi/cmap/app/js/common";
import empty from "bodycodi/cmap/app/img/member-profile-empty.png";
import icon_right_arrow_small from "bodycodi/cmap/app/svg/icon_right_arrow_small.svg";
import Memo from "bodycodi/cmap/app/components/common/Memo";
import MemberType from "bodycodi/cmap/app/components/common/MemberType";

interface DetailContent {
  data: any;
  type: string;
  setScheduleData: any;
  memoReadOnly: string;
  setMemoReadOnly: (memo: string) => void;
}

const DetailContent = ({
  data,
  type,
  setScheduleData,
  memoReadOnly,
  setMemoReadOnly,
}: DetailContent) => {
  const { dispatch: homeDispatch } = useContext(HomeDispatchContext);
  const { dispatch } = useContext(DispatchContext);
  const {
    seqPartner,
    seqPartnerBranch,
    scheduleState,
    scheduleName,
    seqSchedule,
    partnerName,
    partnerBranchName,
    name,
    seqMember,
    age,
    memberMobile,
    appointmentMemberYn,
    chargeMemberYn,
    memo,
    imgUrl,
    startDate,
    endDate,
  } = data;
  const src = isEmpty(imgUrl) ? empty : imgUrl;
  const startDt = new Date(startDate?.split(" ")[0]);
  const startDateText = startDt?.getMonth() + 1 + ". " + startDt.getDate();
  const startTime = timeFormat(startDate?.split(" ")[1].substring(0, 5));
  const endTime = timeFormat(endDate?.split(" ")[1].substring(0, 5));

  const clickMember = () => {
    homeDispatch({
      type: "UPDATE",
      data: {
        memberDtlPopData: {
          seqPartner: seqPartner,
          seqPartnerBranch: seqPartnerBranch,
          seqMember: seqMember,
        },
      },
    });
    dispatch({ type: "POP_UP_OPEN", id: "MEMBER_DTL_POP", open: { memberDtlPop: true } });
  };

  const handleClickMemoPop = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "CHOOSE_SCHEDULE_TYPE",
      open: { memoEditPop: true },
    });
  };

  const handleChangeMemo = (memo: string) => {
    setScheduleData((previousValue: any) => ({
      ScheduleVO: {
        ...previousValue.ScheduleVO,
        memo: blockEmoji(memo),
      },
    }));
  };

  const handleClickUpdateMemo = () => {
    callApi(
      "/cmap2020/execScheduleMemoUpd",
      {
        seqSchedule: seqSchedule,
        memo: memo,
      },
      "POST"
    ).then(({ MsgVO }) => {
      if (MsgVO.msgCd === "CMAP2020-00") {
        setMemoReadOnly(memo);
        dispatch({
          type: "POP_UP_OPEN",
          id: "CHOOSE_SCHEDULE_TYPE",
          open: { memoEditPop: false },
        });
        dispatch({ type: "UPDATE", data: { toast: true, toastText: "수정되었습니다." } });
      }
    });
  };

  return (
    <div className="popup-body ap-dtl-pop">
      <div className="date-wrap">
        <div className="date">
          <span>
            {startDateText}. {getDwk(startDt.getDay())}
          </span>
        </div>
        <div className="time">
          {startTime.ampm} {startTime.time} - {endTime.ampm} {endTime.time}
        </div>
      </div>
      <div className={`schedule-card ot ${type === "기타" ? "et" : "ap"}`}>
        <div className="schedule-type">
          {type}
          {scheduleState === "R" && <span className="blue">예약</span>}
          {scheduleState === "S" && <span className="green1">출석요청중</span>}
          {scheduleState === "E" && <span className="green">출석</span>}
          {scheduleState === "A" && <span className="red">결석</span>}
          {scheduleState === "C" && <span className="red">취소</span>}
        </div>
        <div className="schedule-name memo">{recoverTag(scheduleName)}</div>
        <div className="schedule-partner">
          {partnerName} {partnerBranchName}
        </div>
        {type !== "기타" && (
          <div
            className="schedule-member"
            onClick={
              seqMember === 0
                ? () => {
                    return;
                  }
                : clickMember
            }
          >
            <img className="profile" src={src} />
            <div className="info">
              <div className="title">
                <div className="name">{name}</div>
                <MemberType
                  appointmentMemberYn={appointmentMemberYn}
                  chargeMemberYn={chargeMemberYn}
                  isSmall
                  isMember={seqMember === 0 ? false : true}
                />
              </div>
              {seqMember === 0 ? (
                <div className="age">{memberMobile}</div>
              ) : age === 0 ? (
                <div className="age">
                  {maskingMobile(memberMobile)}
                  <span className="no-age"> &#183; 나이 미설정</span>
                </div>
              ) : (
                <div className="age">
                  {maskingMobile(memberMobile)} &#183; 만 {age}세
                </div>
              )}
            </div>
            {seqMember !== 0 && <img src={icon_right_arrow_small} />}
          </div>
        )}
      </div>
      <Memo
        title="상세메모"
        placeHolder="메모를 입력해주세요."
        memoContent={memo}
        memoReadOnly={memoReadOnly}
        onChangeMemo={handleChangeMemo}
        onClickUpdateMemo={handleClickUpdateMemo}
        onClickMemoPop={handleClickMemoPop}
      />
      <div className="ap-dtl-pop-tip">
        {type} 스케줄로 설정 한 시간에는 수업을 예약할 수 없습니다.
      </div>
    </div>
  );
};

export default DetailContent;
